module.exports = __webpack_public_path__ + "img/TRASH.089b8487.svg";